import React from 'react';

const EditLinearIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.33203 1.32812H5.9987C2.66536 1.32812 1.33203 2.66146 1.33203 5.99479V9.99479C1.33203 13.3281 2.66536 14.6615 5.9987 14.6615H9.9987C13.332 14.6615 14.6654 13.3281 14.6654 9.99479V8.66146"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6972 2.01936L5.44383 7.27269C5.24383 7.47269 5.04383 7.86603 5.00383 8.15269L4.71716 10.1594C4.61049 10.886 5.12383 11.3927 5.85049 11.2927L7.85716 11.006C8.13716 10.966 8.53049 10.766 8.73716 10.566L13.9905 5.31269C14.8972 4.40603 15.3238 3.35269 13.9905 2.01936C12.6572 0.686028 11.6038 1.11269 10.6972 2.01936Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.94141 2.76562C10.3881 4.35896 11.6347 5.60563 13.2347 6.05896"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EditLinearIcon;
